import * as React from "react";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { CloseIcon } from "../Icons";

// A player's stones at the end, for the score columns.
export interface FinalScore {
    name: string;
    stones: number;
    isWinner: boolean;
    // The bottom player, whose wins are shown in the accent colour.
    isBottom: boolean;
}

// Over the board when a game ends: the result, why it ended, the score as two columns (name above stones), the
// series score, a line about a rematch, and the page's buttons.
const GameOverCard: FunctionComponent<{
    title: string,
    reason?: string,
    // The bottom player's first.
    scores: [FinalScore, FinalScore],
    seriesScore?: string,
    status?: string,
    // The status is something being waited for.
    waiting?: boolean,
    children: React.ReactNode,
    onClose: () => void,
}> = ({ title, reason, scores, seriesScore, status, waiting, children, onClose }) => {
    const { t } = useTranslation();
    const scoreColumn = (score: FinalScore) => (
        <div className={"osc" + (score.isWinner ? " win" : "") + (score.isBottom ? " mine" : "")}>
            <span className="oname" title={score.name}>{score.name}</span>
            <span className="onum">{score.stones}</span>
        </div>
    );
    return (
        <div className="over">
            <div className="ocard" role="dialog" aria-label={title}>
                <button className="btn icon ghost close" aria-label={t("Close")} onClick={onClose}><CloseIcon /></button>
                <div className="otitle">{title}</div>
                {reason && <div className="oreason">{reason}</div>}
                <div className="oscore" aria-label={`${t("Score")}: ${scores.map((s) => `${s.name} ${s.stones}`).join(", ")}`}>
                    {scoreColumn(scores[0])}
                    <span className="odash" aria-hidden="true">–</span>
                    {scoreColumn(scores[1])}
                </div>
                {seriesScore && <div className="oseries">{seriesScore}</div>}
                {status && (
                    <div className={"ostatus" + (waiting ? " waiting" : "")} role="status">
                        {waiting && <span className="dot" />}
                        {status}
                    </div>
                )}
                <div className="row">{children}</div>
            </div>
        </div>
    );
};

export default GameOverCard;
